import { BungieError } from '@/utils/exceptions'
import Vue from 'vue'

export const load = ({commit, dispatch}) => {
  commit('setLoading', {loading: 'Loading manifest'})
  Promise.all([
    dispatch('manifest/load'),
    dispatch('loadBungieAccount')
      .then(({membershipId, membershipType}) => {
        return dispatch('profile/load', {membershipId, membershipType})
      })])
    .then(([_, profilePostLoad]) => {
      profilePostLoad()
      commit('setLoading', {loading: false})
    })
    .catch((e) => {
      commit('setLoading', {loading: false})
      dispatch('auth/logout', {}, {root: true})
    })
}

export const loadBungieAccount = ({commit, rootGetters}) => {
  return new Promise((resolve, reject) => {
    Vue.http.get('Platform/User/GetCurrentBungieAccount/').then(({data: response}) => {
      if (response['Message'] === 'Ok') {
        commit('setCurrentUser', {currentUser: response['Response']['bungieNetUser']})
        commit('setDestinyMemberships', {destinyMemberships: response['Response']['destinyMemberships']})
        commit('setCurrentDestinyMembershipIndex', {index: 0})
        resolve(response.Response.destinyMemberships[0])
      } else {
        throw new BungieError(response)
      }
    })
  })
}




// WEBPACK FOOTER //
// ./src/store/destiny/actions.js